export default class Scrolly {
  // data-scrolly="fromBottom", "fromLeft", etc.
  constructor(element) {
    console.log("init");
    this.element = element;
    this.options = {
      rootMargin: "0px",
    };

    this.init();
  }

  init() {
    console.log("init");
    this.observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options,
    );

    const items = this.element.querySelectorAll("[data-scrolly]");
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      this.observer.observe(item);
    }
  }

  watch(entries) {
    for (let i = 0; i < entries.length; i++) {
      console.log("entry");
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        target.classList.add("is-active");

        if ("noRepeat" in target.dataset) {
          // data-no-repeat
          this.observer.unobserve(target);
        }
      } else {
        target.classList.remove("is-active");
      }
    }
  }
}
